import { noop } from 'lodash';
export var ERemote = /*#__PURE__*/function (ERemote) {
  ERemote["RemoteAuth"] = "remote_auth";
  ERemote["RemoteAccountConfiguration"] = "remote_account_configuration";
  ERemote["RemoteChats"] = "remote_chats";
  ERemote["RemoteChecklists"] = "remote_checklists";
  ERemote["RemoteCommon"] = "remote_common";
  ERemote["RemoteFinancial"] = "remote_financial";
  ERemote["RemoteGql"] = "remote_gql";
  ERemote["RemoteInsights"] = "remote_insights";
  ERemote["RemoteInsurances"] = "remote_insurances";
  ERemote["RemoteLumabot"] = "remote_lumabot";
  ERemote["RemotePatientForms"] = "remote_patient_forms";
  ERemote["RemotePatients"] = "remote_patients";
  ERemote["RemoteReferrals"] = "remote_referrals";
  ERemote["RemoteScheduler"] = "remote_scheduler";
  ERemote["RemoteSchedulerCalendar"] = "remote_scheduler_calendar";
  ERemote["RemoteSync"] = "remote_sync";
  ERemote["RemoteTranslations"] = "remote_translations";
  ERemote["RemoteWaitlists"] = "remote_waitlists";
  ERemote["RemoteWizard"] = "remote_wizard";
  ERemote["RemoteWorkflows"] = "remote_workflows";
  return ERemote;
}({});
export var EModule = /*#__PURE__*/function (EModule) {
  EModule["ContainerAuthStaffLogin"] = "ContainerAuthStaffLogin";
  EModule["ContainerAccessDenied"] = "ContainerAccessDenied";
  EModule["ContainerAuthLogin"] = "ContainerAuthLogin";
  EModule["ContainerAuthPasswordForgot"] = "ContainerAuthPasswordForgot";
  EModule["ContainerAuthPasswordReset"] = "ContainerAuthPasswordReset";
  EModule["ContainerAuthPatientLogin"] = "ContainerAuthPatientLogin";
  EModule["ContainerAuthSignup"] = "ContainerAuthSignup";
  EModule["ContainerAuthSignupDemo"] = "ContainerAuthSignupDemo";
  EModule["DialogSessionIdle"] = "DialogSessionIdle";
  EModule["ContainerEHRIntegration"] = "ContainerEHRIntegration";
  EModule["ContainerTableAccountsSetup"] = "ContainerTableAccountsSetup";
  EModule["ContainerFormNumberManagement"] = "ContainerFormNumberManagement";
  EModule["DialogScheduleSettings"] = "DialogScheduleSettings";
  EModule["AlertScheduleSettings"] = "AlertScheduleSettings";
  EModule["ContainerTableNumberManagement"] = "ContainerTableNumberManagement";
  EModule["ContainerThirdPartyIntegration"] = "ContainerThirdPartyIntegration";
  EModule["ContainerFormThirdPartyIntegrationNumberManagement"] = "ContainerFormThirdPartyIntegrationNumberManagement";
  EModule["ContainerTableBroadcasts"] = "ContainerTableBroadcasts";
  EModule["ContainerBroadcastFlow"] = "ContainerBroadcastFlow";
  EModule["ChatMessageAccordionLumaBotFlow"] = "ChatMessageAccordionLumaBotFlow";
  EModule["ChatMessageAccordionNavigator"] = "ChatMessageAccordionNavigator";
  EModule["ChatMessageAccordionVoice"] = "ChatMessageAccordionVoice";
  EModule["ChatPatient"] = "ChatPatient";
  EModule["ChatStaff"] = "ChatStaff";
  EModule["DialogCloseChat"] = "DialogCloseChat";
  EModule["Hub"] = "Hub";
  EModule["InfiniteScrollChatMessages"] = "InfiniteScrollChatMessages";
  EModule["MenuAssignee"] = "MenuAssignee";
  EModule["ContainerChecklistLaunch"] = "ContainerChecklistLaunch";
  EModule["ContainerTableChecklistTemplate"] = "ContainerTableChecklistTemplate";
  EModule["FormChecklistTemplate"] = "FormChecklistTemplate";
  EModule["ButtonPatientMessageTemplate"] = "ButtonPatientMessageTemplate";
  EModule["AccordionActivity"] = "AccordionActivity";
  EModule["AppBarLinks"] = "AppBarLinks";
  EModule["AppBarPatient"] = "AppBarPatient";
  EModule["AppBarStaff"] = "AppBarStaff";
  EModule["BoxFooter"] = "BoxFooter";
  EModule["ButtonActionsAppointment"] = "ButtonActionsAppointment";
  EModule["ButtonActionsBroadcast"] = "ButtonActionsBroadcast";
  EModule["ButtonActionsFeedbackResponse"] = "ButtonActionsFeedbackResponse";
  EModule["ButtonActionsInsurance"] = "ButtonActionsInsurance";
  EModule["ButtonActionsLumaBot"] = "ButtonActionsLumaBot";
  EModule["ButtonActionsMessage"] = "ButtonActionsMessage";
  EModule["ButtonActionsOffer"] = "ButtonActionsOffer";
  EModule["ButtonActionsPatientForm"] = "ButtonActionsPatientForm";
  EModule["ButtonActionsReferral"] = "ButtonActionsReferral";
  EModule["ButtonActionsScheduler"] = "ButtonActionsScheduler";
  EModule["ButtonActionsTelehealth"] = "ButtonActionsTelehealth";
  EModule["ButtonActionsWaitlist"] = "ButtonActionsWaitlist";
  EModule["ButtonLocale"] = "ButtonLocale";
  EModule["ButtonRenderLinks"] = "ButtonRenderLinks";
  EModule["ContainerAdmin"] = "ContainerAdmin";
  EModule["ContainerChat"] = "ContainerChat";
  EModule["ContainerCustomWebStylesBuilder"] = "ContainerCustomWebStylesBuilder";
  EModule["ContainerError"] = "ContainerError";
  EModule["ContainerFeedbackResponse"] = "ContainerFeedbackResponse";
  EModule["ContainerHome"] = "ContainerHome";
  EModule["ContainerLumaBot"] = "ContainerLumaBot";
  EModule["ContainerNotFound"] = "ContainerNotFound";
  EModule["ContainerTableActionQueue"] = "ContainerTableActionQueue";
  EModule["FormPatient"] = "FormPatient";
  EModule["GridShortcuts"] = "GridShortcuts";
  EModule["Telehealth"] = "Telehealth";
  EModule["ToolbarLocation"] = "ToolbarLocation";
  EModule["ButtonLumaPayRequest"] = "ButtonLumaPayRequest";
  EModule["ContainerPayment"] = "ContainerPayment";
  EModule["ContainerPaymentWithToolbar"] = "ContainerPaymentWithToolbar";
  EModule["ContainerTablePayments"] = "ContainerTablePayments";
  EModule["DialogPaymentAudit"] = "DialogPaymentAudit";
  EModule["DialogPaymentRefund"] = "DialogPaymentRefund";
  EModule["DialogUploadFinancial"] = "DialogUploadFinancial";
  EModule["ButtonFilters"] = "ButtonFilters";
  EModule["ChartSankey"] = "ChartSankey";
  EModule["ContainerTableClosedChatRecords"] = "ContainerTableClosedChatRecords";
  EModule["ContainerROICalculator"] = "ContainerROICalculator";
  EModule["ChipSparkAssistantAccuracy"] = "ChipSparkAssistantAccuracy";
  EModule["TypographyAIOutput"] = "TypographyAIOutput";
  EModule["ChipSparkAssistantStatus"] = "ChipSparkAssistantStatus";
  EModule["ContainerDetailsSparkMonitoring"] = "ContainerDetailsSparkMonitoring";
  EModule["ContainerTableSparkMonitoring"] = "ContainerTableSparkMonitoring";
  EModule["GridTrends"] = "GridTrends";
  EModule["ContainerReports"] = "ContainerReports";
  EModule["ContainerInsightsOverview"] = "ContainerInsightsOverview";
  EModule["ContainerInsightsCenterMonitoring"] = "ContainerInsightsCenterMonitoring";
  EModule["ContainerProviderUtilization"] = "ContainerProviderUtilization";
  EModule["ContainerInsightsCenterReports"] = "ContainerInsightsCenterReports";
  EModule["ContainerInsightsRecommendations"] = "ContainerInsightsRecommendations";
  EModule["ContainerTablePatientJourney"] = "ContainerTablePatientJourney";
  EModule["ContainerEligibilitySetup"] = "ContainerEligibilitySetup";
  EModule["ContainerPayerManagement"] = "ContainerPayerManagement";
  EModule["InsuranceManagement"] = "InsuranceManagement";
  EModule["ContainerInsuranceManagement"] = "ContainerInsuranceManagement";
  EModule["ContainerFormInsuranceDetails"] = "ContainerFormInsuranceDetails";
  EModule["ContainerCopayDeterminationAppointmentDetails"] = "ContainerCopayDeterminationAppointmentDetails";
  EModule["ContainerCopayDetermination"] = "ContainerCopayDetermination";
  EModule["FormInsurance"] = "FormInsurance";
  EModule["LumaBot"] = "LumaBot";
  EModule["ButtonPatientFormSimulator"] = "ButtonPatientFormSimulator";
  EModule["ContainerPatientFormTemplateBuilder"] = "ContainerPatientFormTemplateBuilder";
  EModule["ContainerPatientFormJumpLogic"] = "ContainerPatientFormJumpLogic";
  EModule["ContainerPatientFormLaunch"] = "ContainerPatientFormLaunch";
  EModule["ContainerPatientFormTemplateLaunch"] = "ContainerPatientFormTemplateLaunch";
  EModule["FormPatientFormJumpLogicVariables"] = "FormPatientFormJumpLogicVariables";
  EModule["DialogPatientFormJumpLogic"] = "DialogPatientFormJumpLogic";
  EModule["FormPatientFormJumpLogic"] = "FormPatientFormJumpLogic";
  EModule["ContainerPatientFiles"] = "ContainerPatientFiles";
  EModule["StackPatientDetails"] = "StackPatientDetails";
  EModule["DialogDuplicatedPatient"] = "DialogDuplicatedPatient";
  EModule["ButtonPatientSearch"] = "ButtonPatientSearch";
  EModule["ContainerPatient"] = "ContainerPatient";
  EModule["ContainerPatientAppointments"] = "ContainerPatientAppointments";
  EModule["ContainerPatientChat"] = "ContainerPatientChat";
  EModule["ContainerPatientFinancial"] = "ContainerPatientFinancial";
  EModule["ContainerPatientInfo"] = "ContainerPatientInfo";
  EModule["ContainerPatientInsurance"] = "ContainerPatientInsurance";
  EModule["ContainerPatientJourney"] = "ContainerPatientJourney";
  EModule["ContainerPatientOffers"] = "ContainerPatientOffers";
  EModule["ContainerPatientReminders"] = "ContainerPatientReminders";
  EModule["ContainerPatientSchedule"] = "ContainerPatientSchedule";
  EModule["ContainerPatientWaitlists"] = "ContainerPatientWaitlists";
  EModule["ContainerTablePatients"] = "ContainerTablePatients";
  EModule["DialogPatientSearch"] = "DialogPatientSearch";
  EModule["ContainerFormEhrAssignees"] = "ContainerFormEhrAssignees";
  EModule["ContainerTableEhrAssignees"] = "ContainerTableEhrAssignees";
  EModule["ContainerTableFaxManagement"] = "ContainerTableFaxManagement";
  EModule["ContainerTableFaxWorkflows"] = "ContainerTableFaxWorkflows";
  EModule["ContainerFormFaxWorkflow"] = "ContainerFormFaxWorkflow";
  EModule["ContainerFaxDetails"] = "ContainerFaxDetails";
  EModule["ContainerTableFaxAutomation"] = "ContainerTableFaxAutomation";
  EModule["ContainerTableFaxDocumentTypeManagement"] = "ContainerTableFaxDocumentTypeManagement";
  EModule["ContainerFormFaxDocumentTypeManagement"] = "ContainerFormFaxDocumentTypeManagement";
  EModule["ContainerTableReferralsInbound"] = "ContainerTableReferralsInbound";
  EModule["ContainerTableReferralsOutbound"] = "ContainerTableReferralsOutbound";
  EModule["DialogAddReferringProvider"] = "DialogAddReferringProvider";
  EModule["FormReferralInbound"] = "FormReferralInbound";
  EModule["FormReferralOutbound"] = "FormReferralOutbound";
  EModule["FormReferralUpload"] = "FormReferralUpload";
  EModule["ContainerAvailabilitiesPicker"] = "ContainerAvailabilitiesPicker";
  EModule["ContainerAvailabilitiesPicker2"] = "ContainerAvailabilitiesPicker2";
  EModule["ContainerAvailabilityBook"] = "ContainerAvailabilityBook";
  EModule["ContainerCalendar"] = "ContainerCalendar";
  EModule["ContainerFormStaffPatientForm"] = "ContainerFormStaffPatientForm";
  EModule["ContainerStaffScheduler"] = "ContainerStaffScheduler";
  EModule["ContainerTableScheduler"] = "ContainerTableScheduler";
  EModule["FormWaitlist"] = "FormWaitlist";
  EModule["PanelAppointment"] = "PanelAppointment";
  EModule["DialogAppointment"] = "DialogAppointment";
  EModule["ContainerSchedulerCalendar"] = "ContainerSchedulerCalendar";
  EModule["StackSyncAppointments"] = "StackSyncAppointments";
  EModule["ContainerTableResourceSync"] = "ContainerTableResourceSync";
  EModule["ContainerTableSyncFreshnessMap"] = "ContainerTableSyncFreshnessMap";
  EModule["GridSync"] = "GridSync";
  EModule["DialogMessageTranslation"] = "DialogMessageTranslation";
  EModule["ButtonMessageTemplatesTranslation"] = "ButtonMessageTemplatesTranslation";
  EModule["PanelQueueManagerInstance"] = "PanelQueueManagerInstance";
  EModule["ContainerQueueManagerBoard"] = "ContainerQueueManagerBoard";
  EModule["ContainerQueueManagerBuilder"] = "ContainerQueueManagerBuilder";
  EModule["ContainerTableQueueManagerTemplate"] = "ContainerTableQueueManagerTemplate";
  EModule["ContainerQueueManagerWorkspace"] = "ContainerQueueManagerWorkspace";
  EModule["ContainerAppointment"] = "ContainerAppointment";
  EModule["ContainerListAppointments"] = "ContainerListAppointments";
  EModule["ContainerTableOffers"] = "ContainerTableOffers";
  EModule["ContainerTableWaitlists"] = "ContainerTableWaitlists";
  EModule["ListAppointments"] = "ListAppointments";
  EModule["ContainerTableBroadcastTemplates"] = "ContainerTableBroadcastTemplates";
  EModule["ContainerBuilderAssistants"] = "ContainerBuilderAssistants";
  EModule["ContainerTableFollowupWorkflowInstances"] = "ContainerTableFollowupWorkflowInstances";
  EModule["ContainerTableFollowupWorkflows"] = "ContainerTableFollowupWorkflows";
  EModule["ContainerFollowupWorkflowBuilder"] = "ContainerFollowupWorkflowBuilder";
  EModule["ContainerTableAssistants"] = "ContainerTableAssistants";
  EModule["ContainerTableWorkflows"] = "ContainerTableWorkflows";
  EModule["FilterModelField"] = "FilterModelField";
  EModule["FormFollowup"] = "FormFollowup";
  EModule["MenuFollowupActions"] = "MenuFollowupActions";
  EModule["DialogSummarizeTemplate"] = "DialogSummarizeTemplate";
  EModule["ContainerGridWizardProducts"] = "ContainerGridWizardProducts";
  EModule["FormWorkflow"] = "FormWorkflow";
  EModule["ContainerMessagingActivity"] = "ContainerMessagingActivity";
  EModule["FormBroadcast"] = "FormBroadcast";
  EModule["ContainerTableRecalls"] = "ContainerTableRecalls";
  EModule["ContainerTableAppointments"] = "ContainerTableAppointments";
  EModule["ContainerTableDocuments"] = "ContainerTableDocuments";
  EModule["ContainerFeedback"] = "ContainerFeedback";
  EModule["ContainerInsurance"] = "ContainerInsurance";
  EModule["ContainerWaitingRoom"] = "ContainerWaitingRoom";
  EModule["ContainerPatientFormTemplates"] = "ContainerPatientFormTemplates";
  EModule["ContainerSettingsHome"] = "ContainerSettingsHome";
  EModule["ContainerTableApptTypes"] = "ContainerTableApptTypes";
  EModule["ContainerTableFacilities"] = "ContainerTableFacilities";
  EModule["ContainerTableFormResponses"] = "ContainerTableFormResponses";
  EModule["ContainerTableGroups"] = "ContainerTableGroups";
  EModule["ContainerTableLumaBotFlows"] = "ContainerTableLumaBotFlows";
  EModule["ContainerTablePatientForms"] = "ContainerTablePatientForms";
  EModule["ContainerTableProviders"] = "ContainerTableProviders";
  EModule["ContainerTableUploadCenter"] = "ContainerTableUploadCenter";
  EModule["ContainerTableUsers"] = "ContainerTableUsers";
  EModule["FormAppt"] = "FormAppt";
  EModule["FormApptType"] = "FormApptType";
  EModule["FormFacility"] = "FormFacility";
  EModule["FormGroup"] = "FormGroup";
  EModule["FormLumaBotFlow"] = "FormLumaBotFlow";
  EModule["FormLumaBotFlowTemplate"] = "FormLumaBotFlowTemplate";
  EModule["FormOffer"] = "FormOffer";
  EModule["FormPatientForm"] = "FormPatientForm";
  EModule["FormPatientFormReviewAnswers"] = "FormPatientFormReviewAnswers";
  EModule["FormPatientFormTemplate"] = "FormPatientFormTemplate";
  EModule["FormPatientMessageTemplate"] = "FormPatientMessageTemplate";
  EModule["FormProvider"] = "FormProvider";
  EModule["FormReminder"] = "FormReminder";
  EModule["FormUser"] = "FormUser";
  EModule["UtilityCustomActions"] = "UtilityCustomActions";
  EModule["None"] = "None";
  EModule["Test"] = "Test";
  return EModule;
}({});
export var ETabItem = /*#__PURE__*/function (ETabItem) {
  ETabItem[ETabItem["Home"] = 0] = "Home";
  ETabItem[ETabItem["BackofficeHome"] = 1] = "BackofficeHome";
  ETabItem[ETabItem["Chat"] = 2] = "Chat";
  ETabItem[ETabItem["Schedule"] = 3] = "Schedule";
  ETabItem[ETabItem["SchedulerAssist"] = 4] = "SchedulerAssist";
  ETabItem[ETabItem["Intake"] = 5] = "Intake";
  ETabItem[ETabItem["Feedback"] = 6] = "Feedback";
  ETabItem[ETabItem["Calendar"] = 7] = "Calendar";
  ETabItem[ETabItem["Waitlists"] = 8] = "Waitlists";
  ETabItem[ETabItem["WaitingRoom"] = 9] = "WaitingRoom";
  ETabItem[ETabItem["Broadcasts"] = 10] = "Broadcasts";
  ETabItem[ETabItem["Recalls"] = 11] = "Recalls";
  ETabItem[ETabItem["ReferralsInbound"] = 12] = "ReferralsInbound";
  ETabItem[ETabItem["ReferralsOutbound"] = 13] = "ReferralsOutbound";
  ETabItem[ETabItem["LumaPay"] = 14] = "LumaPay";
  ETabItem[ETabItem["Insurance"] = 15] = "Insurance";
  ETabItem[ETabItem["Reports"] = 16] = "Reports";
  ETabItem[ETabItem["Insights"] = 17] = "Insights";
  ETabItem[ETabItem["Monitoring"] = 18] = "Monitoring";
  ETabItem[ETabItem["PatientJourney"] = 19] = "PatientJourney";
  ETabItem[ETabItem["ProviderUtilization"] = 20] = "ProviderUtilization";
  ETabItem[ETabItem["InsightsReports"] = 21] = "InsightsReports";
  ETabItem[ETabItem["ExecutiveSummary"] = 22] = "ExecutiveSummary";
  ETabItem[ETabItem["Recommendations"] = 23] = "Recommendations";
  ETabItem[ETabItem["Workflows"] = 24] = "Workflows";
  ETabItem[ETabItem["FaxAutomation"] = 25] = "FaxAutomation";
  ETabItem[ETabItem["QueueManager"] = 26] = "QueueManager";
  return ETabItem;
}({});

// Optional props handled by the patient app

export var EFaxTabs = /*#__PURE__*/function (EFaxTabs) {
  EFaxTabs["MyFaxes"] = "myFaxes";
  EFaxTabs["Completed"] = "completed";
  return EFaxTabs;
}({});
export var ECloseChatReasons = /*#__PURE__*/function (ECloseChatReasons) {
  ECloseChatReasons["NotActionable"] = "not-actionable";
  ECloseChatReasons["Offensive"] = "offensive";
  ECloseChatReasons["Spam"] = "spam";
  ECloseChatReasons["NoFurtherAction"] = "no-further-action";
  ECloseChatReasons["NotRelevant"] = "not-relevant";
  ECloseChatReasons["Other"] = "other";
  return ECloseChatReasons;
}({});

// custom props for some components

// fallback for `Container*` components

// fallback for `ContainerTable*` components

// fallback for components that require an `id`

// fallback for components that require an `id` and `patient`

// fallback for ContainerPatientInsurance

// fallback for ContainerTableNumberManagement

// fallback for ContainerTableFaxManagement

// fallback for ContainerFormThirdPartyIntegrationNumberManagement

// fallback for ContainerPatientInsurance

// fallback for PanelAppointment

// fallback for ContainerEHRIntegration

// fallback for other components that can be navigated to

function navigateToModule(module, props, options) {
  noop(module, props, options);
}